import { module } from 'angular';

import {
  AgentBookingSocialNetworkInprocessForward,
  default as agentBookingSocialNetworkInprocessForward,
} from './inprocess-forward/agent-booking-social-network-inprocess-forward.component.ajs';
import {
  AgentBookingSocialNetworkInprocess,
  default as agentBookingSocialNetworkInprocess,
} from './inprocess/agent-booking-social-network-inprocess.component.ajs';
import {
  AgentBookingSocialNetworkQualification,
  default as agentBookingSocialNetworkQualification,
} from './qualification/agent-booking-social-network-qualification.component.ajs';

export default module('contact.agent.contact-view.social-network.state', [])
  .component(agentBookingSocialNetworkInprocess, new AgentBookingSocialNetworkInprocess())
  .component(agentBookingSocialNetworkInprocessForward, new AgentBookingSocialNetworkInprocessForward())
  .component(agentBookingSocialNetworkQualification, new AgentBookingSocialNetworkQualification()).name;
